/* eslint-disable */
import db from '../db/index';
import moment from 'moment';
import { doc, collection, setDoc, getDoc, getDocs, updateDoc, increment, arrayUnion } from 'firebase/firestore';
import { getAllBadges } from '../data/badgeData';

const BADGES = getAllBadges();

// CheckIns
const getDailyCheckInStatus = async uid => {
    const userSnapshot = await getDoc(doc(db, 'profiles', uid));
    const user = userSnapshot.data();

    return user.checkin;
};

const updateDailyCheckIn = async({ uid, dailyCheckInSurvey }) => {
    const today = moment();

    const docRef = doc(db, 'profiles', uid, 'checkIns', today.format('YYYY-MM'));
    await setDoc(docRef, {
        [today.format('YYYY-MM-DD')]: dailyCheckInSurvey,
    }, { merge: true });
};

const updateDailyCheckInStatus = async({ uid }) => {
    await updateDoc(doc(db, 'profiles', uid), {
        streaks: increment(1),
        checkin: true,
    });
};

// Badges
const getUnlockedBadges = async uid => {
    const userSnapshot = await getDoc(doc(db, 'profiles', uid));
    const user = userSnapshot.data();    
    
    return user.unlockedBadges;
};

const getCurrentStreaks = async uid => {
    const userSnapshot = await getDoc(doc(db, 'profiles', uid));
    const user = userSnapshot.data();    
    
    return user.streaks;
}

const getTotalNumberOfCheckIns = async uid => {
    const checkInsSnapshot = await getDocs(collection(db, 'profiles', uid, 'checkIns'));

    let count = 0;
    checkInsSnapshot.docs.forEach(doc => {
        count += Object.keys(doc.data()).length;
    })

    return count;
}

const updateUnlockedBadges = async ({ uid, id }) => {
    const docRef = doc(db, 'profiles', uid);

    await updateDoc(docRef, {
        unlockedBadges: arrayUnion(id),
    });
}

const updateBadges = async ({ uid }) => {

    const [currentStreaks, totalCheckIns, unlockBadges] = await Promise.all([
        getCurrentStreaks(uid),
        getTotalNumberOfCheckIns(uid),
        getUnlockedBadges(uid),
    ]);
        
    const conditions = {
        0: currentStreaks + 1 >= 60, // checked in for 60 consecutive days
        1: totalCheckIns + 1 >= 30, // checked in for a total of 30 days
        2: getCurrentStreaks + 1 >= 7, // checked in for 7 consecutive days
        3: totalCheckIns + 1 >= 1, // checked in for the first time
    };

    const newBadges = [];
    for (const id in BADGES) {
        if (!unlockBadges || !unlockBadges.includes(id)) {
            if (conditions[id]) {
                newBadges.push(BADGES[id].name);
                await updateUnlockedBadges({ uid, id });
            }
        }
    }
    return newBadges;
};

export {
    getDailyCheckInStatus,
    updateDailyCheckIn,
    updateDailyCheckInStatus,
    getUnlockedBadges,
    getCurrentStreaks,
    getTotalNumberOfCheckIns,
    updateUnlockedBadges,
    updateBadges,
};
